export const getDecodedToken = (token: any) => {
    if (token) return JSON.parse(window.atob(token.split('.')[1]));
    return null;
}